<template>
<div>

    <v-text-field
        :label="label"
        v-if="field.type == 'text'"
        :value="value"
        v-on:input="onInput"
        :hint="field.hint"
        persistent-hint
    />

     <v-text-field
        :label="label"
        v-if="field.type == 'email'"
        type="email"
        :value="value"
        v-on:input="onInput"
        :hint="field.hint"
        persistent-hint
    />

    <v-text-field
        :label="label"
        v-if="field.type == 'number'"
        :value="value"
        v-on:input="onInput"
        :hint="field.hint"
        persistent-hint
    />

    <v-select
        :label="label"
        v-if="field.type == 'multiple-choice'"
        :items="field.choices"
        :value="value"
        v-on:change="onInput"
        :hint="field.hint"
        persistent-hint
        :multiple="field.allow_multiple_select"
        :chips="field.allow_multiple_select"
    />

    <div
        v-if="field.type == 'payment' && profile != null && profile.payment != null"
    >
        <m-make-payment-invoice-and-amount
            :payment="profile.payment"
            auto_hide_amount
        />

        <m-make-payment-address
            v-if="show_shipping_address"
            shipping
            fluid
            :payment="profile.payment"
            :active="false"
            ref="shipping-address"
            v-on:input="onInputPayment"
        />

        <m-make-payment-address
            fluid
            :payment="profile.payment"
            v-if="show_billing_address"
            ref="billing-address"
            :allow_same_as_shipping="allow_same_as_shipping"
            v-on:input="onInputPayment"
        />

        <m-make-payment-pay-by-card
            fluid
            :payment="profile.payment"
            v-if="payment_mode == 'credit'"
            v-on:swich-to-pay-by-ach="onSwitchToPayByACH"
            ref="pay-by-card"
            :show_pay_button="false"
            v-on:input="onInputPayment"
            v-on:fill-sample="onFillSample"
        />

        <m-make-payment-pay-by-ach
            fluid
            :payment="profile.payment"
            v-if="payment_mode == 'ach'"
            ref="pay-by-ach"
            v-on:swich-to-pay-by-credit="onSwitchToPayByCredit"
            :show_pay_button="false"
            v-on:input="onInputPayment"
        />

    </div>

   <m-showdown
        v-if="field.extended_description != null"
        style="margin-top: 15px"
        :value="field.extended_description"
   >
   </m-showdown>

</div>
</template>

<script>
export default {
    props: {
        field: {
            type: Object,
            default: function() { return {}; }
        },

        value: {
            type: String,
            default: function() { return null; }
        },

        profile: {
            type: Object,
            default: function() { return null; }
        },
    }, 

    data() {
        return {
            payment_mode: 'credit',
        }
    },

    methods: {
        onInput(new_val) {
            this.$emit('input',new_val);
        },

        onSwitchToPayByACH()
        {
            if ( !this.accept_ach ) return;
            this.payment_mode = 'ach';
        },

        onSwitchToPayByCredit()
        {
            if ( !this.accept_ach ) return;
            this.payment_mode = 'credit';
        },

        validate()
        {
           // Called externally to validate the contents of the control...
           let ctrl;
           
           ctrl = this.$refs['shipping-address'];

           if ( ctrl != null )
           {
                let ret = ctrl.validate();
                if ( ret != null )
                    return ret;
           }

           ctrl = this.$refs['billing-address'];

           if ( ctrl != null )
           {
                let ret = ctrl.validate();
                if ( ret != null )
                    return ret;
           }

           ctrl = this.$refs['pay-by-card'];

           if ( ctrl != null && this.payment_mode == 'credit' )
           {
                let ret = ctrl.validate();
                if ( ret != null )
                    return ret;
           }

           ctrl = this.$refs['pay-by-ach'];

           if ( ctrl != null && this.payment_mode == 'ach' )
           {
                let ret = ctrl.validate();
                if ( ret != null )
                    return ret;
           }

           return null;
        },


        onInputPayment()
        {
            this.$emit('input-payment', this.createPayment());
        },

        createPayment()
        {
            let payment_info_credit_card = null;
            let payment_info_ach = null;
            let age_verification_provided_text = null;

            if ( this.payment_mode == 'credit' )
            {
                payment_info_credit_card = this.$refs['pay-by-card'].createPaymentInfoCreditCard();

                if ( payment_info_credit_card.error != null )
                {
                    return { 'error': payment_info_credit_card.error }; 
                }

                age_verification_provided_text = payment_info_credit_card.age_verification_provided_text;
            }
            else
            {
                payment_info_ach = this.$refs['pay-by-ach'].createPaymentInfo();

                if ( payment_info_ach.error != null )
                {
                    return { 'error': payment_info_ach.error }; 
                }

                age_verification_provided_text = payment_info_ach.age_verification_provided_text;
            }

            let billing_address = null;
            let shipping_address = null;

            if ( this.show_shipping_address )
            {
                shipping_address = this.$refs['shipping-address'].createAddress();
            
                if ( shipping_address.error != null )
                {
                    return { 'error': shipping_address.error }; 
                }
            }

            if ( this.show_billing_address )
            {
                billing_address = this.$refs['billing-address'].createAddress();

                if ( billing_address.error != null )
                {
                    return { 'error': billing_address.error }; 
                }

                if ( billing_address.same_as_shipping == true )
                    billing_address = shipping_address;
            }

            return {
                'response_time' : new Date().getTime(),
                'payment_info_credit_card' : payment_info_credit_card,
                'payment_info_ach': payment_info_ach,
                'billing_address' : billing_address,
                'shipping_address' : shipping_address,
                'age_verification_provided_text' : age_verification_provided_text,
            };
        },
    },

    computed: {
        label() {
            if ( this.field == null ) return null;
            
            let ret = this.field.label ?? '';
            ret = ret.trim();

            if ( ret.length == 0 )
                return 'Blank Label (Label Required)';

            return this.field.label;
        },

        show_shipping_address() {
            let value = this.$rc.getDeep(this.profile, 'payment/request/amount_of_address_information');
            return value == 'billing-and-shipping-address';
        },

        show_billing_address() 
        {
            let value = this.$rc.getDeep(this.profile, 'payment/request/amount_of_address_information');
            return value == 'billing-and-shipping-address' || value == 'billing-address';
        },

        allow_same_as_shipping() {
            let value = this.$rc.getDeep(this.profile, 'payment/request/amount_of_address_information');
            return value == 'billing-and-shipping-address';
        },

        accept_ach()
        {
            let value = this.$rc.getDeep(this.profile, 'payment/request/accept_ach');
            if ( value == null ) value = false;

            return value;
        },

        accept_credit()
        {
            let ret;
            
            ret = this.$rc.getDeep(this.profile, 'payment/request/accept_visa');
            if ( ret == true ) return ret;

            ret = this.$rc.getDeep(this.profile, 'payment/request/accept_mastercard');
            if ( ret == true ) return ret;

            ret = this.$rc.getDeep(this.profile, 'payment/request/accept_amex');
            if ( ret == true ) return ret;

            ret = this.$rc.getDeep(this.profile, 'payment/request/accept_discover');
            if ( ret == true ) return ret;

            return false;
        },
    },
}
</script>

<style lang="scss" scoped>

</style>